import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sale-booking",
  "use": "icon-sale-booking-usage",
  "viewBox": "0 0 21 27",
  "content": "<symbol viewBox=\"0 0 21 27\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sale-booking\">\n<path d=\"M18.375 0C19.8248 0 21 1.20883 21 2.7V18.3408C21 19.0569 20.7235 19.7436 20.2311 20.25L14.4375 26.2092C13.9452 26.7156 13.2775 27 12.5814 27H2.625C1.17525 27 0 25.7912 0 24.3V2.7C0 1.20883 1.17525 0 2.625 0H18.375ZM18.375 2.7H2.625V24.3H10.5V18.225C10.5 17.1067 11.3815 16.2 12.4688 16.2H18.375V2.7ZM17.8314 18.9H13.125V23.7408L17.8314 18.9ZM7.875 12.15C8.59989 12.15 9.1875 12.7544 9.1875 13.5C9.1875 14.2456 8.59989 14.85 7.875 14.85H6.5625C5.83763 14.85 5.25 14.2456 5.25 13.5C5.25 12.7544 5.83763 12.15 6.5625 12.15H7.875ZM14.4375 6.75C15.1624 6.75 15.75 7.35441 15.75 8.1C15.75 8.84559 15.1624 9.45 14.4375 9.45H6.5625C5.83763 9.45 5.25 8.84559 5.25 8.1C5.25 7.35441 5.83763 6.75 6.5625 6.75H14.4375Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/sale-booking.svg
// module id = xmlX
// module chunks = 262